<div class="modal-header d-flex justify-content-between">
    <div class="row thumbs_icon">
      <div class="ml-2">
        <h5 class="modal-title" id="exampleModalLongTitle"><span class="font-weight-bold text_baseline">ALERT</span>
        </h5>
      </div>
    </div>
  </div>
  <div class="modal-body text-center px-5 py-5">
    <h5 class="text-center mt-2 mb-2">Please settle the batch to edit the TPN.</h5>
  </div>
  
  <div class="card-footer pb-2">
    <div class="text-right m-1">
        <button (click)="activeModal.close('Close');" class="mt-2 text-right btn btn-danger mr-2">Close</button>
        <button (click)="activeModal.close('goToBatches');" [routerLink]="'/batch-management/batches'" [queryParams]="queryParam" class="mt-2 text-right btn btn-primary mr-2">Go To Batches</button>
      </div>
  </div>